// ---- route constants start -----
const ROUTE_NAME = {
  pet: 'pet',
  ENTRY: 'entry',
  ENTRY_WITH_SALES_PARTNER_NUMBER: 'entry-sales-partner-number',
  PET_DETAILS: 'pet-details',
  HEALTH_QUESTIONS: 'health-questions',
  HEALTH_QUESTIONS_REJECTION: 'health-questions-rejection',
  PRODUCTS_SELECTION: 'products',
  OVERVIEW: 'overview',
  SUBMIT: 'submit',
  SUCCESS: 'success',
  REENTRY: 'reentry',
  UNSUBSCRIBE: 'unsubscribe',
  ERROR: 'error',
  UNLICENSED_SALES_PARTNER_ERROR: 'unlicensed-sales-partner-error'
}

const ROUTE_INDEX = {
  pet: 0,
  ENTRY: 1,
  ENTRY_WITH_SALES_PARTNER_NUMBER: 1,
  PET_DETAILS: 2,
  HEALTH_QUESTIONS: 3,
  HEALTH_QUESTIONS_REJECTION: 3,
  PRODUCTS_SELECTION: 4,
  OVERVIEW: 5,
  SUBMIT: 6,
  SUCCESS: 7,
  REENTRY: 8,
  UNSUBSCRIBE: 9,
  ERROR: 10,
  UNLICENSED_SALES_PARTNER_ERROR: 11
}
// ---- route constants end -----

export const PET_ROUTES = {
  pet: {
    name: ROUTE_NAME.pet,
    index: ROUTE_INDEX.pet,
  },
  ENTRY: {
    name: ROUTE_NAME.ENTRY,
    index: ROUTE_INDEX.ENTRY,
  },
  ENTRY_WITH_SALES_PARTNER_NUMBER: {
    name: ROUTE_NAME.ENTRY_WITH_SALES_PARTNER_NUMBER,
    index: ROUTE_INDEX.ENTRY_WITH_SALES_PARTNER_NUMBER,
  },
  PET_DETAILS: {
    name: ROUTE_NAME.PET_DETAILS,
    index: ROUTE_INDEX.PET_DETAILS,
  },
  HEALTH_QUESTIONS: {
    name: ROUTE_NAME.HEALTH_QUESTIONS,
    index: ROUTE_INDEX.HEALTH_QUESTIONS,
  },
  HEALTH_QUESTIONS_REJECTION: {
    name: ROUTE_NAME.HEALTH_QUESTIONS_REJECTION,
    index: ROUTE_INDEX.HEALTH_QUESTIONS_REJECTION,
  },
  PRODUCTS_SELECTION: {
    name: ROUTE_NAME.PRODUCTS_SELECTION,
    index: ROUTE_INDEX.PRODUCTS_SELECTION,
  },
  OVERVIEW: {
    name: ROUTE_NAME.OVERVIEW,
    index: ROUTE_INDEX.OVERVIEW,
  },
  SUBMIT: {
    name: ROUTE_NAME.SUBMIT,
    index: ROUTE_INDEX.SUBMIT,
  },
  SUCCESS: {
    name: ROUTE_NAME.SUCCESS,
    index: ROUTE_INDEX.SUCCESS,
  },
  REENTRY: {
    name: ROUTE_NAME.REENTRY,
    index: ROUTE_INDEX.REENTRY,
  },
  UNSUBSCRIBE: {
    name: ROUTE_NAME.UNSUBSCRIBE,
    index: ROUTE_INDEX.UNSUBSCRIBE,
  },
  ERROR: {
    name: ROUTE_NAME.ERROR,
    index: ROUTE_INDEX.ERROR,
  },
  UNLICENSED_SALES_PARTNER_ERROR: {
    name: ROUTE_NAME.UNLICENSED_SALES_PARTNER_ERROR,
    index: ROUTE_INDEX.UNLICENSED_SALES_PARTNER_ERROR,
  }
}
